
  var _styles = {
  "commonTabBase": {
    "flexDirection": "column",
    "position": "absolute",
    "left": 0,
    "top": 0,
    "width": "5rem"
  }
};



  module.exports = _styles;
  